// extracted by mini-css-extract-plugin
export default {"form":"register_form__p2XtE","imgWrapper":"register_imgWrapper__Q45RG"};